module.exports = __webpack_public_path__ + "static/media/48.a6e3236e.png";